import { Button } from '@edsn/pie-components';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { Message } from '#pie/components/message/Message';
import { Text } from '#pie/components/text/Text';
import { Answer, type CreateDataRequestDto } from '#pie/internal/api/pie-bff';
import { typedFormFields } from '#pie/utils/typedFormFields';

export const PersonalDataLegalBasis = ({
  setNoLegalBasis,
}: {
  setNoLegalBasis: (value: boolean) => void;
}) => {
  //Heeft de desbetreffende netbeheerder een grondslag voor het verwerken van persoonsgegevens voor dit dataverzoek?
  const { t } = useTranslation('dataRequest');
  const { FormRadio, ConditionalField } =
    typedFormFields<CreateDataRequestDto>();
  const { watch } = useFormContext<CreateDataRequestDto>();
  const noLegalBasis = watch('legalBasisPersonalData') === Answer.No;

  useEffect(() => {
    setNoLegalBasis(noLegalBasis);
  }, [noLegalBasis, setNoLegalBasis]);

  const YesNoDontKnowOptions = [
    {
      label: t(`answer.${Answer.Yes}`),
      value: Answer.Yes,
    },
    {
      label: t(`answer.${Answer.No}`),
      value: Answer.No,
    },
    {
      label: t(`answer.${Answer.DontKnow}`),
      value: Answer.DontKnow,
    },
  ];

  return (
    <>
      <ConditionalField
        field="legalBasisPersonalData"
        condition={(formValue) =>
          formValue('informationIsPersonalData') === Answer.Yes
        }
      >
        <FormRadio
          name="legalBasisPersonalData"
          label={t('legal_basis_personal_data')}
          options={YesNoDontKnowOptions}
          rules={{ required: true }}
        />
      </ConditionalField>

      {noLegalBasis && (
        <>
          <Message variant="warning">
            <Text>{t('legal_basis_personal_data.no_basis_explainer')}</Text>
          </Message>
          <Button
            as={Link}
            action="secondary"
            emphasis="bold"
            to="/datadiensten"
          >
            {t('legal_basis_personal_data.end_request')}
          </Button>
        </>
      )}
    </>
  );
};
